"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortableIconChips = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var react_sortablejs_1 = require("react-sortablejs");
var atoms_1 = require("../../atoms");
var styles_1 = __importDefault(require("./styles"));
exports.SortableIconChips = react_1.default.memo(function (_a) {
    var handleCheckAll = _a.handleCheckAll, handleCheck = _a.handleCheck, list = _a.list, setList = _a.setList, _b = _a.initialCheckAll, initialCheckAll = _b === void 0 ? false : _b, _c = _a.hideClose, hideClose = _c === void 0 ? true : _c, _d = _a.selectAllId, selectAllId = _d === void 0 ? 'FlowFormSelectAllCheckbox' : _d;
    var styles = (0, styles_1.default)();
    var _e = (0, react_1.useState)(initialCheckAll), checkAll = _e[0], setCheckAll = _e[1];
    var onCheckAll = (0, react_1.useCallback)(function (event) {
        var value = list === null || list === void 0 ? void 0 : list.map(function (option) { return (__assign(__assign({}, option), { checked: !checkAll })); });
        setList(value);
        setCheckAll(!checkAll);
        if (handleCheckAll)
            handleCheckAll(event, value);
    }, [checkAll, handleCheckAll, list, setList]);
    (0, react_1.useEffect)(function () {
        if (initialCheckAll) {
            var newList = list.map(function (option) { return (__assign(__assign({}, option), { checked: true })); });
            setList(newList);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var onCheckOption = (0, react_1.useCallback)(function (event, item) {
        var tempList = __spreadArray([], list, true);
        var clicked = list.find(function (i) { return i.id === item.id; });
        if (!clicked)
            return;
        clicked.checked = event.target.checked;
        var index = list.findIndex(function (i) { return i.id === item.id; });
        tempList.splice(index, 1, clicked);
        var value = clicked ? tempList : list;
        setList(value);
        if (handleCheck)
            handleCheck(event, value);
    }, [handleCheck, list, setList]);
    var optionsLength = list.length || 0;
    var isIndeterminate = checkAll === true && (list === null || list === void 0 ? void 0 : list.some(function (option) { return option.checked === false; }));
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: styles.root }, { children: list.length > 0 && ((0, jsx_runtime_1.jsx)(atoms_1.Checkbox, { role: "menuitemcheckbox", label: checkAll ? 'Unselect all' : 'Select all', id: selectAllId, checked: checkAll, indeterminate: isIndeterminate === true, onChange: onCheckAll, disabled: !optionsLength, labelStyles: { fontWeight: 'bold' } })) })), (0, jsx_runtime_1.jsx)(react_sortablejs_1.ReactSortable, __assign({ list: list, setList: setList, handle: ".drag-handle", className: styles.sortableContainer }, { children: list.map(function (_a) {
                    var id = _a.id, rest = __rest(_a, ["id"]);
                    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: styles.iconChipContainer }, { children: (0, jsx_runtime_1.jsx)(atoms_1.IconChip, __assign({ draggable: true, checkable: true, hideClose: hideClose, id: rest.name }, rest, { onChange: function (e) { return onCheckOption(e, __assign({ id: id }, rest)); } }), id) }), id));
                }) }))] }));
});
